(function (app, common, core) {
    'use strict';

    const TEMPLATE = 'common.news-listing';
    const TABLET_BREAKPOINT = window.matchMedia( '(max-width: 840px)' );

    const NUMBERS = {
        ZERO: 0,
        THREE: 3,
        FOUR: 4,
        EIGHT: 8,
        FIVE: 5,
        NINE: 9,
        ONE_HUNDRED: 100,
        TWELVE_HUNDRED: 1200,
        FIVE_THOUSAND: 5000
    };

    app.AuthorsBios = function ( container ) {
        const _self = this;

        _self.container = container;
        _self.contentTypes = 'text';
        _self.authorsArticles = _self.container.querySelector( '.js-authors-articles' );
        _self.tags = _self.container.getAttribute( 'data-tags' ).toLowerCase() || '';
        _self.contentContainer = _self.container.querySelector( '.js-content-list' );
        _self.contentListingWidget = _self.container.querySelector( '[data-widget="content-listing"]');
        _self.widgetHeader = _self.container.querySelector( '.js-content-list' );
        _self.loadMoreBtn = _self.container.querySelector( '.js-load-more' );
        _self.loader = _self.container.querySelector( '.js-loader' );
        core.style.removeClass( _self.loader, 'u-hide' );
        _self.authorBio = _self.container.querySelector( '.js-author-bio' );
        _self.renderedArticles = NUMBERS.ZERO;
        _self.nextRender = TABLET_BREAKPOINT.matches ? NUMBERS.FIVE : NUMBERS.NINE;

        if ( _self.authorBio ) {
            _self.widgetHeader = _self.authorBio.querySelector( '.widget-header' );
            _self.name = _self.container.querySelector( '.js-name' );
            _self.checkHeaderPosition();
        }

        _self.fetchData();
        _self.pageIndex = 0;
        new common.ContentListing( _self.container );
    };

    app.AuthorsBios.prototype.checkHeaderPosition = function () {
        const _self = this;

        const options = {
            root: null,
            threshold: 0,
            rootMargin: "20px",
        }

        const observer = new IntersectionObserver( _self.intersection.bind( _self ), options );
        observer.observe( _self.widgetHeader );
    };

    app.AuthorsBios.prototype.intersection = function ( entries ) {
        const _self = this;

        if ( entries[0].intersectionRect.top >= 0 ) {
            _self.name.style.setProperty( 'opacity', 1 , 'important' );
            _self.name.style.setProperty( 'opacity', 1 , 'important' );
        } else if ( _self.name.style.opacity !== 1 ) {
            _self.name.style.opacity = 0;
        }
    }

    app.AuthorsBios.prototype.setListeners = function () {
        const _self = this;

        _self.loadMoreBtn.addEventListener('click', _self.loadMore.bind(_self));
    };

    app.AuthorsBios.prototype.fetchData = function () {
        const _self = this;

        let params = {
            contentTypes: _self.contentTypes,
            tagNames: _self.tags,
            pageSize: NUMBERS.ONE_HUNDRED
        };

        _self.preLoadTransitions();
        _self.setListeners();
        let url = common.createContentPath( '', params, app.language );
        core.data.request( url, 'GET', _self.renderContent.bind( _self ), _self );
    };

    app.AuthorsBios.prototype.loadMore = function () {
        const _self = this;

        _self.pageIndex++;
        _self.nextRender = TABLET_BREAKPOINT.matches ? NUMBERS.FOUR : NUMBERS.EIGHT;
        _self.preLoadTransitions();
        _self.renderContent();
    };

    app.AuthorsBios.prototype.renderContent = function ( data ) {
        const _self = this;

        _self.data = _self.data ? _self.data : data;
        let isFeatured = false;
        let renderDate = true;

        const items = _self.data.content || [];
        if ( items.length > 0 && items[ _self.renderedArticles ] ) {
            items.forEach( ( item, idx ) => {
                idx === NUMBERS.ZERO ? ( isFeatured = true ) : ( isFeatured = false );
                if ( idx >= _self.renderedArticles && idx < ( _self.renderedArticles + _self.nextRender ) ){
                    _self.contentContainer.innerHTML += app.templating.render ( { item, isFeatured, renderDate }, TEMPLATE );
                }
            });
            new common.ContentListing( _self.contentListingWidget );
        } else {
            _self.contentContainer.innerHTML += '<div class="news-listing__no-news-msg">' + PULSE.I18N.lookup('label.svns.nofurtherarticlesfromthisauthor') + '</div>';
        }
        _self.loadTransitions();
        _self.renderedArticles = _self.renderedArticles + _self.nextRender;
        _self.checkRemainingContent();
    };

    app.AuthorsBios.prototype.preLoadTransitions = function () {
        const _self = this;

        _self.contentCurrentHeight = _self.contentContainer.offsetHeight;
        _self.contentContainer.style.maxHeight = _self.contentCurrentHeight + 'px';
    };

    app.AuthorsBios.prototype.loadTransitions = function () {
        const _self = this;

        core.style.addClass( _self.loader, 'u-hide' );
        core.style.removeClass( _self.loadMoreBtn, 'u-hide' );
        _self.contentContainer.style.maxHeight = _self.renderedArticles === NUMBERS.ZERO ? NUMBERS.FIVE_THOUSAND + 'px' : _self.contentCurrentHeight * NUMBERS.THREE + 'px';
        setTimeout(() => {
            _self.preLoadTransitions();
        }, NUMBERS.TWELVE_HUNDRED );
    };

    app.AuthorsBios.prototype.checkRemainingContent = function () {
        const _self = this;

        const test = _self.renderedArticles + 1 ;
        if ( _self.data.content.length <= test) {
            core.style.addClass( _self.loadMoreBtn, 'u-hide' );
        }
    };

    let widgets = document.querySelectorAll( '[ data-widget="authors-bios" ]' );
    Array.prototype.forEach.call( widgets, function ( widget ) {
        new app.AuthorsBios( widget );
    });
})( PULSE.app, PULSE.app.common, PULSE.core );
